// modal/detail/ui/StatCard.jsx
import React from 'react';
import Card from '@mui/material/Card';
import MDBox from 'components/MDBox';
import MDTypography from 'components/MDTypography';
import { useTheme as useMuiTheme } from '@mui/material/styles';

import { PillIcon } from './PillIcon';
import { TONES } from './constants';

export function StatCard({ tone = 'teal', icon, label, value, hint, valueTone = 'normal' }) {
  const theme = useMuiTheme();
  const t = TONES[tone] || TONES.teal;

  let valueSx = {};
  if (valueTone === 'good') valueSx = { color: theme.palette.success.main };
  if (valueTone === 'bad') valueSx = { color: theme.palette.error.main };

  return (
    <Card
      sx={{
        p: 1.6,
        borderRadius: '18px',
        border: `1px solid ${theme.palette.divider}`,
        boxShadow: theme.shadows[2],
        background: theme.palette.background.paper,
      }}
    >
      <MDBox display="flex" alignItems="center" gap={1.2}>
        <PillIcon icon={icon} tone={tone} />
        <MDBox sx={{ minWidth: 0 }}>
          <MDTypography variant="caption" fontWeight="bold" sx={{ opacity: 0.85 }}>
            {label}
          </MDTypography>

          <MDTypography
            variant="h6"
            fontWeight="bold"
            sx={{
              lineHeight: 1.12,
              mt: 0.25,
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              ...valueSx,
            }}
          >
            {value}
          </MDTypography>

          {hint ? (
            <MDTypography variant="caption" sx={{ color: theme.palette.text.secondary }}>
              {hint}
            </MDTypography>
          ) : null}
        </MDBox>

        <MDBox
          sx={{
            ml: 'auto',
            width: 8,
            height: 34,
            borderRadius: '999px',
            background: `linear-gradient(180deg, ${t.fg}, transparent)`,
            opacity: 0.22,
          }}
        />
      </MDBox>
    </Card>
  );
}
